import { FlowStepModel } from "../../models";

export function FlowStepJsonViewer({ step, data }: { step: FlowStepModel; data: any }) {
  return (
    <div className="flex flex-col flex-1 gap-4">
      <textarea className="flex-1 rounded-md" defaultValue={JSON.stringify(step, null, 4)} readOnly />
    </div>
  );
}
